import {
  OPENTOK_FETCH_TEST_SESSION_DATA_SUCCESS,
  OPENTOK_FETCH_CANDIDATE_SESSION_DATA_SUCCESS,
  OPENTOK_UPDATE_ARCHIVE_DATA_SUCCESS,
  OPENTOK_STREAMING_TOGGLE,
  OPENTOK_RECORDING_TOGGLE,
  OPENTOK_RECONNECTING_TOGGLE,
  OPENTOK_SET_RECORDING_SESSION_DATA,
  OPENTOK_ERROR,
  OPENTOK_PUBLISHER_SET,
  OPENTOK_SESSION_SET,
  OPENTOK_RESET_DATA,
  OPENTOK_CANDIDATE_SESSION_INIT,
  OPENTOK_RECORDING_SESSION_INIT,
  OPENTOK_UPDATE_CONNECTION_COUNT,
  OPENTOK_UPDATE_ARCHIVE_FROM_EVENT,
  OPENTOK_STREAM_STARTING_TOGGLE,
} from 'actions/opentok'

export default function reducer(state, action = {}) {
  const newState = { ...state }

  switch (action.type) {
    case OPENTOK_FETCH_TEST_SESSION_DATA_SUCCESS:
      newState.apiKey = action.apiKey
      newState.testSessionData.sessionId = action.sessionId
      newState.testSessionData.token = action.token
      newState.error = ''
      newState.responseSaved = false
      break

    case OPENTOK_FETCH_CANDIDATE_SESSION_DATA_SUCCESS:
      newState.apiKey = action.apiKey
      newState.candidateSessionData.sessionId = action.sessionId
      newState.candidateSessionData.token = action.token
      newState.error = ''
      newState.responseSaved = false
      break

    case OPENTOK_SET_RECORDING_SESSION_DATA:
      newState.apiKey = action.payload.apiKey
      newState.recordingSessionData.sessionId = action.payload.sessionId
      newState.recordingSessionData.token = action.payload.token
      newState.error = ''
      newState.responseSaved = false
      break

    case OPENTOK_UPDATE_ARCHIVE_DATA_SUCCESS:
      newState.archive = action.archive
      newState.error = ''

      if (action.responseSaved) {
        newState.responseSaved = action.responseSaved
      } else {
        newState.responseSaved = false
      }
      break

    case OPENTOK_UPDATE_ARCHIVE_FROM_EVENT:
      newState.archiveFromEvent = action.archive
      break

    case OPENTOK_ERROR:
      newState.responseSaved = false
      newState.error = action.error
      break

    case OPENTOK_STREAMING_TOGGLE:
      newState.streaming = action.payload
      break

    case OPENTOK_STREAM_STARTING_TOGGLE:
      newState.streamStarting = action.payload
      break

    case OPENTOK_RECORDING_TOGGLE:
      newState.responseSaved = false
      newState.recording = action.payload
      break

    case OPENTOK_RECONNECTING_TOGGLE:
      if (action.payload === false) {
        newState.error = ''
      }
      newState.reconnecting = action.payload
      break

    case OPENTOK_CANDIDATE_SESSION_INIT:
      newState.session = action.session
      break

    case OPENTOK_RECORDING_SESSION_INIT:
      newState.session = action.session
      break

    case OPENTOK_PUBLISHER_SET:
      newState.publisher = action.payload.publisher

      if (action.payload.publisherElementId) {
        newState.publisherElement = action.payload.publisherElementId
      } else {
        newState.publisherElement = undefined
      }
      break

    case OPENTOK_SESSION_SET:
      newState.session = action.session
      break

    case OPENTOK_UPDATE_CONNECTION_COUNT:
      newState.connectionCount = action.payload
      break

    case OPENTOK_RESET_DATA:
      newState.error = ''
      newState.connectionCount = 0
      newState.recording = false
      newState.reconnecting = false
      newState.streaming = false
      newState.streamStarting = false
      newState.archive = undefined
      newState.publisherElement = undefined
      newState.session = undefined
      newState.publisher = undefined

      if (action.resetOpentokSessionData) {
        newState.recordingSessionData = {}
      }
      break

    default:
  }

  return newState
}
